
import { CalendarEventDisplayItem } from '../api/CalendarEventDisplayItem';
import { CalendarEventUpdateItem } from '../api/CalendarEventUpdateItem';
import { CalendarEventInputItem } from '../api/CalendarEventInputItem';
import { CalendarEventUpdateStudentChangeMode } from '../api/Enums';

declare module '../api/CalendarEventDisplayItem' {
    namespace CalendarEventDisplayItem {
        let ConvertToUpdateItem: typeof convertToUpdateItem;
        let ConvertToInputItem: typeof convertToInputItem;
    }
    export interface CalendarEventDisplayItem {
        EventType: string;
    }
}

declare module '../api/CalendarBirthdayEventDisplayItem' {
    namespace CalendarBirthdayEventDisplayItem {}  
    export interface CalendarBirthdayEventDisplayItem {
        EventType: string;
    }
}

declare module '../api/CalendarRepertoirePerformanceDisplayItem' {
    namespace CalendarRepertoirePerformanceDisplayItem {}       
    export interface CalendarRepertoirePerformanceDisplayItem {
        EventType: string;
    }
}

declare module '../api/CalendarHoldDisplayItem' {
    namespace CalendarHoldDisplayItem {}       
    export interface CalendarHoldDisplayItem {
        EventType: string;
    }
}

declare module '../api/ExternalEventDisplayItem' {
    namespace ExternalEventDisplayItem {}       
    export interface ExternalEventDisplayItem {
        EventType: string;
    }
}

CalendarEventDisplayItem.ConvertToUpdateItem = convertToUpdateItem;
CalendarEventDisplayItem.ConvertToInputItem = convertToInputItem;

function convertToUpdateItem(displayItem: CalendarEventDisplayItem): CalendarEventUpdateItem {
    return new CalendarEventUpdateItem({
        AllDay: displayItem.AllDay,
        StudentChangeMode: CalendarEventUpdateStudentChangeMode.Absolute,
        StudentIDs: displayItem.Attendances.map(attendance => attendance.StudentID!),
        Description: displayItem.Description,
        DisplayDescriptionOnCalendar: displayItem.DisplayDescriptionOnCalendar,
        Duration: displayItem.Duration,
        EventLocationID: displayItem.EventLocation?.ID ?? null,
        EventCategoryID: displayItem.EventCategory!.ID,
        IsPublic: displayItem.IsPublic,
        MakeupRequired: displayItem.MakeupRequired,
        MaximumNumberOfParticipants: displayItem.MaximumNumberOfParticipants,
        PricePerParticipant: displayItem.PricePerParticipant,
        PricePerParticipantType: displayItem.PricePerParticipantType,
        PrivateDescription: displayItem.PrivateDescription,
        RepeatDetails: displayItem.RepeatDetails,
        StartDate: displayItem.StartDate,
        TeacherID: displayItem.TeacherID,
        EventTaxIDs: displayItem.EventTaxIDs,
        OriginalTeacherID: displayItem.OriginalTeacherID,
        UpdateFutureEvents: false,
        HoldTimeSlot: displayItem.HoldTimeSlot,
    });
}

export function convertToInputItem(displayItem: CalendarEventDisplayItem): CalendarEventInputItem {
    return new CalendarEventInputItem({
        AllDay: displayItem.AllDay,
        StudentIDs: [],
        Description: displayItem.Description,
        DisplayDescriptionOnCalendar: displayItem.DisplayDescriptionOnCalendar,
        Duration: displayItem.Duration,
        EventLocationID: displayItem.EventLocation ? displayItem.EventLocation.ID : null,
        EventCategoryID: displayItem.EventCategory ? displayItem.EventCategory.ID : null,
        EventTaxIDs: displayItem.EventTaxIDs,
        IsPublic: displayItem.IsPublic,
        MakeupRequired: displayItem.MakeupRequired,
        MaximumNumberOfParticipants: displayItem.MaximumNumberOfParticipants,
        OriginalTeacherID: displayItem.OriginalTeacherID,
        PricePerParticipant: displayItem.PricePerParticipant,
        PricePerParticipantType: displayItem.PricePerParticipantType,
        PrivateDescription: displayItem.PrivateDescription,
        RepeatDetails: displayItem.RepeatDetails,
        StartDate: displayItem.StartDate,
        TeacherID: displayItem.TeacherID,
        HoldTimeSlot: displayItem.HoldTimeSlot
    });
}